import { render, staticRenderFns } from "./SettingRemind.vue?vue&type=template&id=ec8489f8&scoped=true"
import script from "./SettingRemind.vue?vue&type=script&lang=js"
export * from "./SettingRemind.vue?vue&type=script&lang=js"
import style0 from "./SettingRemind.vue?vue&type=style&index=0&id=ec8489f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8489f8",
  null
  
)

export default component.exports